export const modalCloseConfirm = {
	question: 'Are you sure you want to close the form without saving?',
	children: 'Your current changes will be lost.',
};

export const MODAL_CLOSE_BUTTON_AND_PADDING_WIDTH = 105;
